import React from 'react';
import { withTranslation } from 'react-i18next';
import Backend from '../../../../Layouts/Backend';
import UnitForm from '../UnitForm';

class NewUnitPage extends React.Component {
  constructor(props) {
    super(props);
  }
  onEditUnit = (values) => {
    const { units, scale, offset, description } = values;
    this.props.onEditUnit({ units, scale, offset, description });
  };
  render() {
    if (Object.keys(this.props.getUnitError).length) {
      return (
        <Backend>
          <div className="content-inner">
            <h1>{this.props.t('This unit is unavailable')}</h1>
          </div>
        </Backend>
      );
    }
    return (
      <UnitForm
        {...this.props}
        initialValues={this.props.unit}
        loading={this.props.isSubmitting}
        onSubmit={(values) => this.onEditUnit(values)}
      />
    );
  }
}
export default withTranslation('app')(NewUnitPage);
